(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8353],{

/***/ 82301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/settings",
      function () {
        return __webpack_require__(43974);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Section; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _section_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40184);
/* harmony import */ var _section_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_section_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Section = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section), props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
Section.defaultProps = {};


/***/ }),

/***/ 11202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ProfileAvatarForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73053);
/* harmony import */ var shared_ui_avatar_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43880);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32636);





const ProfileAvatarForm = (props)=>{
    var _profile_data, _profile_data1, _profile_data2, _profile_data3, _profile_data_avatarImage;
    const profile = shared_api__WEBPACK_IMPORTED_MODULE_2__/* .api.userProfile.useUserProfileMe */ .h.userProfile.useUserProfileMe();
    const updateAvatar = async (value)=>{
        if (!profile.data) return;
        await shared_api__WEBPACK_IMPORTED_MODULE_2__/* .api.userProfile.userProfileUpdate */ .h.userProfile.userProfileUpdate({
            ...profile.data,
            avatarImageId: value || null
        });
        await profile.mutate();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset */ .p, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset.Content */ .p.Content, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui_avatar_input__WEBPACK_IMPORTED_MODULE_4__/* .AvatarInput */ .P, {
                            id: (_profile_data = profile.data) === null || _profile_data === void 0 ? void 0 : _profile_data.id,
                            name: ((_profile_data1 = profile.data) === null || _profile_data1 === void 0 ? void 0 : _profile_data1.name) || ((_profile_data2 = profile.data) === null || _profile_data2 === void 0 ? void 0 : _profile_data2.email),
                            value: (_profile_data3 = profile.data) === null || _profile_data3 === void 0 ? void 0 : (_profile_data_avatarImage = _profile_data3.avatarImage) === null || _profile_data_avatarImage === void 0 ? void 0 : _profile_data_avatarImage.id,
                            onChange: updateAvatar,
                            style: {
                                float: "right"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset.Title */ .p.Title, {
                            children: "Аватар"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset.Subtitle */ .p.Subtitle, {
                            children: [
                                "Нажмите на него, чтобы загрузить файлы.",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "Также вы можете ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    onClick: ()=>updateAvatar(undefined),
                                    children: "удалить"
                                }),
                                " аватар."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset.Footer */ .p.Footer, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset.Footer.Status */ .p.Footer.Status, {
                        children: "Аватар опционален, но рекомендуется его установить"
                    })
                })
            ]
        })
    });
};
ProfileAvatarForm.defaultProps = {};


/***/ }),

/***/ 51816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ProfileNameForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73053);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99088);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76780);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32636);




const ProfileNameForm = (props)=>{
    var _profile_data, _profile_data1;
    const profile = shared_api__WEBPACK_IMPORTED_MODULE_2__/* .api.userProfile.useUserProfileMe */ .h.userProfile.useUserProfileMe();
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const onSubmit = async (e)=>{
        var _profile_data_avatarImage;
        e.preventDefault();
        if (!profile.data || !value) return;
        await shared_api__WEBPACK_IMPORTED_MODULE_2__/* .api.userProfile.userProfileUpdate */ .h.userProfile.userProfileUpdate({
            name: value,
            avatarImageId: ((_profile_data_avatarImage = profile.data.avatarImage) === null || _profile_data_avatarImage === void 0 ? void 0 : _profile_data_avatarImage.id) || null
        });
        await profile.mutate();
        setValue(undefined);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset */ .p, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset.Content */ .p.Content, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset.Title */ .p.Title, {
                            children: "Имя, Фамилия"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset.Subtitle */ .p.Subtitle, {
                            children: "Укажите ваше имя и фамилию. Они будут видны другим сотрудникам вашей компании."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_4__/* .Input */ .I, {
                            style: {
                                maxWidth: 300
                            },
                            name: "name",
                            value: value !== null && value !== void 0 ? value : (_profile_data = profile.data) === null || _profile_data === void 0 ? void 0 : _profile_data.name,
                            placeholder: ((_profile_data1 = profile.data) === null || _profile_data1 === void 0 ? void 0 : _profile_data1.name) === "" ? profile.data.email : undefined,
                            onChange: (e)=>setValue(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset.Footer */ .p.Footer, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset.Footer.Status */ .p.Footer.Status, {
                            children: "Максимум 32 символа"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_3__/* .Fieldset.Footer.Actions */ .p.Footer.Actions, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                                htmlType: "submit",
                                size: "small",
                                disabled: !value,
                                children: "Сохранить"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
ProfileNameForm.defaultProps = {};


/***/ }),

/***/ 85674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var modules_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95244);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35622);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35629);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47656);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6480);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pages_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32636);
/* harmony import */ var _layout_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36194);
/* harmony import */ var _layout_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_layout_module_scss__WEBPACK_IMPORTED_MODULE_5__);








const ProfileLayout = (props)=>{
    (0,modules_auth__WEBPACK_IMPORTED_MODULE_3__/* .useGuardAuthedOnly */ .T)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const profile = shared_api__WEBPACK_IMPORTED_MODULE_4__/* .api.userProfile.useUserProfileMe */ .h.userProfile.useUserProfileMe();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_layout_module_scss__WEBPACK_IMPORTED_MODULE_5___default().profile_page),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_6__/* .HeaderDashboard */ .w, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_7__/* .HeaderTitle */ .G, {
                className: (_layout_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header),
                children: "Профиль"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_8__/* .WithSidebarContainer */ .I, {
                mainHref: pages_router__WEBPACK_IMPORTED_MODULE_9__/* ["default"].profile.href */ .Z.profile.href,
                sidebar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_10__/* .Sidebar */ .Y, {
                    mainHref: pages_router__WEBPACK_IMPORTED_MODULE_9__/* ["default"].profile.href */ .Z.profile.href,
                    menu: [
                        {
                            label: "Настройки",
                            href: pages_router__WEBPACK_IMPORTED_MODULE_9__/* ["default"].profile.href */ .Z.profile.href,
                            exact: true,
                            additionalHref: pages_router__WEBPACK_IMPORTED_MODULE_9__/* ["default"].profile.settings */ .Z.profile.settings
                        },
                        {
                            label: "Выход",
                            href: pages_router__WEBPACK_IMPORTED_MODULE_9__/* ["default"].logout.href */ .Z.logout.href
                        }
                    ]
                }),
                children: props.children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProfileLayout);


/***/ }),

/***/ 43974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5880);
/* harmony import */ var modules_profile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11202);
/* harmony import */ var modules_profile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51816);
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85674);




const ProfileSettings = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_2__/* .Section */ .$, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_profile__WEBPACK_IMPORTED_MODULE_3__/* .ProfileAvatarForm */ .$, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_2__/* .Section */ .$, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_profile__WEBPACK_IMPORTED_MODULE_4__/* .ProfileNameForm */ .H, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProfileSettings);


/***/ }),

/***/ 40184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__JGk_2"};

/***/ }),

/***/ 36194:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"_layout_header__8cjgZ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7165,5675,1664,6657,4321,4894,8972,9774,2888,179], function() { return __webpack_exec__(82301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);